import type { BlankPresetFieldMapParams } from '../types'
import { getFieldKeysForPreset } from './getFieldKeysForPreset'

export const createBlankPresetFieldMap = ({
  fields,
  itemPageLinkFieldKey,
  indexPageLinkFieldKey,
}: BlankPresetFieldMapParams) => {
  const fieldKeysForPreset = getFieldKeysForPreset(fields)

  return {
    title: fieldKeysForPreset.titleFieldKey,
    shortDescription: fieldKeysForPreset.shortDescriptionFieldKey,
    longDescription: fieldKeysForPreset.longDescriptionFieldKey,
    image: fieldKeysForPreset.imageFieldKey,
    imagesAltText: fieldKeysForPreset.imagesAltTextFieldKey,
    'link-items-title': itemPageLinkFieldKey,
    'link-items-all': indexPageLinkFieldKey,
  }
}
